import { cn } from "@/utils/utils";
import { motion, Transition } from "motion/react";

export type BorderTrailProps = {
  className?: string;
  transition?: Transition;
  onAnimationComplete?: () => void;
  style?: React.CSSProperties;
};

export function BorderTrail({
  className,
  transition,
  onAnimationComplete,
  style,
}: BorderTrailProps) {
  const defaultTransition: Transition = {
    repeat: Infinity,
    duration: 7,
    ease: "linear",
  };

  return (
    <div className="pointer-events-none absolute inset-0 rounded-[inherit] border border-transparent [container-type:size] [mask-clip:padding-box,border-box] [mask-composite:intersect] [mask-image:linear-gradient(transparent,transparent),linear-gradient(#000,#000)]">
      <motion.div
        className={cn("absolute", className)}
        style={{
          width: "100px",
          aspectRatio: "2 / 1",
          background:
            "radial-gradient(100% 100% at right center, hsl(var(--brand)), transparent 50%)",
          offsetPath: "border-box",
          offsetAnchor: "100% 50%",
          ...style,
        }}
        animate={{
          offsetDistance: ["0%", "100%"],
        }}
        transition={transition || defaultTransition}
        onAnimationComplete={onAnimationComplete}
      />
    </div>
  );
}
